module.exports = __webpack_public_path__ + "img/361.61f9877c.jpg";